export const blockIconsBusinessandpaymentsMonitoringNew = (
	<span className='material-symbols-outlined'>monitoring</span>
);
